import {debug} from '@/shared/helpers/debug';
import z from 'zod';

// TODO: Enable required fields again once all env vars are ensured to be provided in each environment
// const reqiredIfApp = isHybridApp ? z.string() : z.string().optional();
// const requiredIfProd = import.meta.env.PROD && !isHybridApp ? z.string() : z.string().optional();

const reqiredIfApp = z.string().optional();
const requiredIfProd = z.string().optional();

const environmentScheme = z.object({
    VITE_SENTRY_DSN_JS: requiredIfProd,
    VITE_SENTRY_ENVIRONMENT: requiredIfProd,
    VITE_BASE_URL: reqiredIfApp,
    VITE_APP_VERSION: requiredIfProd,
    VITE_DEV_BASE_URL: requiredIfProd,
    // Authentication
    VITE_OAUTH_AZURE_ID: requiredIfProd,
    VITE_OAUTH_GOOGLE_ID: requiredIfProd,
    // App
    VITE_IOS_BUNDLE_ID: reqiredIfApp,
    VITE_ANDROID_PACKAGE_ID: reqiredIfApp,
    VITE_OAUTH_GOOGLE_IOS_ID: reqiredIfApp,
});

const parsedEnv = environmentScheme.safeParse(import.meta.env);
if (!parsedEnv.success) {
    debug.error('❌ Invalid environment variables:', parsedEnv.error.format(), import.meta.env);
    throw new Error('Invalid environment variables');
}

export const environment = parsedEnv.data;
